import React from "react";
import styles from '../formikDateSelector/FormikDateSelector.module.scss';
import FormErrorDisplay from '../formErrorDisplay';
import {getDatePlusDays} from 'data/utils/calculators';
import DateField from "./components/dateField";

export interface IOriginSelectorProps {
  label: string;
  options: string[];
  rtl: boolean;
  field?: any;
  form?: any;
  handleChange?: any;
  noBorder?: boolean;
  minDate?: Date;
  maxDate?: Date;
  openTo?: string;
}

const FormikDateTimeSelector = (props: IOriginSelectorProps) => {
  const touched = props.form.touched[props.field.name];
  const error = touched && props.form.errors[props.field.name];
  const valid = touched && !error;
  return (
    <>
      <DateField
        name={props.field.name}
        label={props.label}
        value={props.field.value}

        onChange={(value) => {
          props.field.onChange({
            target: {
              name: props.field.name,
              value: value.toDate().getTime(),
            },
          });
          if (props.handleChange)
            props.handleChange(value.toDate().getTime());
        }}
        onBlur={props.field.onBlur}
        minDate={props.minDate}
        maxDate={props.maxDate}
        openTo={props.openTo as any}
        noBorder={props.noBorder}
        valid={valid}
        error={error}
      />
      <FormErrorDisplay
        className={styles.displayError}
        error={error}
      />
    </>
  );
};

FormikDateTimeSelector.defaultProps = {
  options: [],
  rtl: true,
  minDate: getDatePlusDays(1),
  maxDate: getDatePlusDays(365 * 100, new Date()),
  openTo: 'date',
};

export default FormikDateTimeSelector;
